import { useEffect, useState } from 'react';
import { downloadLocalFile, getTimeWithTimeZone, produce } from 'utility/general';
import CustomLink from 'components/CustomLink';
import { GET_DOWNLOAD_DOCUMENT } from 'store/key';
import { useDispatch, useSelector } from 'react-redux';
import usePrevious from 'hooks/usePrevious';
import { isEqual } from 'lodash';
import API from 'api/call';

const useUploadDocData = ({ isPermission, data }) => {
    const dispatch = useDispatch();
    const user = useSelector((state) => state.user);
    const [rows, setRows] = useState([]);
    const [addSupplements, setAddSupplements] = useState([]);
    const previousData = usePrevious(data?.supplementDocuments);
    const [deleteSupplements, setDeleteSupplements] = useState([]);

    useEffect(() => {
        const currentData = data?.supplementDocuments ?? [];

        const check = isEqual(currentData, previousData);

        if (!check) {
            setRows(currentData);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [previousData, data]);

    const getDownloadDocument = (row, type) => {
        if (row.tempFile) {
            downloadLocalFile(row.tempFile);
        } else {
            dispatch({
                type: GET_DOWNLOAD_DOCUMENT,
                payload: {
                    data: {
                        id: row.id,
                    },
                    apiUrl: API.susarReport.downloadDocument,
                },
            });
        }
    };

    const getFileNameContent = (params, type) => {
        let fileName = params.getValue('fileName');

        return (
            <CustomLink isStopJumping onClick={() => getDownloadDocument(params.row, type)}>
                {fileName}
            </CustomLink>
        );
    };

    const defaultUploadDocFormList = {
        fileName: {
            alignItems: 'baseline',
            value: [],
            label: 'File Name',
            name: 'fileName',
            type: 'uploadFile',
            multiple: true,
            validators: ['isRequired'],
            enableRemove: true,
        },
    };

    const columns = [
        {
            field: 'createDtm',
            headerName: 'Upload Date',
            width: 200,
            valueGetter: (params) => {
                let date = params.getValue('createDtm');
                date = date ? getTimeWithTimeZone(date).format('YYYY-MM-DD') : '-';
                return date;
            },
        },
        { field: 'createdBy', headerName: 'Uploaded By', width: 200 },
        {
            field: 'fileName',
            headerName: 'File',
            width: 300,
            valueGetter: (params) => getFileNameContent(params),
        },
    ];

    const [showUploadDocDialog, setShowUploadDocDialog] = useState(false);

    const handleUploadDocUpdate = (row) => {
        const newRows = row.fileName.map((item, index) => {
            return {
                id: item.key,
                // uploadTempId: item.key,
                createDtm: new Date(),
                createdBy: `${user.detail.surname} ${user.detail.firstName}`,
                fileName: item.name,
                tempFile: item.tempFile
            };
        });

        setAddSupplements([...addSupplements, ...newRows.map((item) => item.id)]);
        setRows([...rows, ...newRows]);
    };

    const handleUploadDocDelete = (row) => {
        const { id: idToRemove } = row;

        setRows(
            produce((draft) => {
                const index = draft.findIndex((item) => {
                    return item.id === idToRemove;
                });

                draft.splice(index, 1);
            }),
        );

        const index = addSupplements.findIndex((item) => {
            return item === idToRemove;
        });

        if (index !== -1) {
            setAddSupplements(
                produce((draft) => {
                    const idx = draft.findIndex((item) => {
                        return item === idToRemove;
                    });
                    draft.splice(idx, 1);
                }),
            );
        } else {
            setDeleteSupplements(
                produce((draft) => {
                    draft.push(idToRemove);
                }),
            );
        }
    };

    const resetUploadData = () => {
        setAddSupplements([]);
        setDeleteSupplements([]);
    };

    return {
        columns,
        rows,
        setRows,
        defaultUploadDocFormList,
        showUploadDocDialog,
        setShowUploadDocDialog,
        handleUploadDocUpdate,
        handleUploadDocDelete,
        addSupplements,
        deleteSupplements,
        resetUploadData,
    };
};
export default useUploadDocData;
